import { render, staticRenderFns } from "./Barriers.vue?vue&type=template&id=bcc280d0&scoped=true"
import script from "./Barriers.vue?vue&type=script&lang=ts&setup=true"
export * from "./Barriers.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Barriers.vue?vue&type=style&index=0&id=bcc280d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc280d0",
  null
  
)

export default component.exports